import { GridButtons } from "@/controls/buttons/GridButtons";
import { Cassette } from "@/pages/catalogs/models/Cassette";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (cassette: Cassette) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "LocationName",
			headerName: "Location",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "RivCassetteChockName",
			headerName: "Riv Chock",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "AveCassetteChockName",
			headerName: "Ave Chock",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Cassette,
				edit: false,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "cassetteContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			maxWidth: 180,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
